import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "app/services/auth.service";
import { GlobalService } from "app/services/global.service";
import { LocalService } from "app/services/local.service";
import { PageService } from "app/services/page-service";

@Component({
  selector: "app-update-request-status",
  templateUrl: "./update-request-status.component.html",
  styles: [],
})
export class UpdateRequestStatusComponent implements OnInit {
  @Input() content: any;
  contentForm: FormGroup;

  statusLists = [];
  submitted = false;
  loader = false;
  errorMessage = "";
  orderId = "";

  constructor(
    public service: PageService,
    public fb: FormBuilder,
    public router: Router,
    public global: GlobalService,
    public dialogRef: NgbActiveModal
  ) {}

  ngOnInit(): void {
    console.log(this.content.status);
    this.statusLists = this.content["data"];
    console.log(this.statusLists);
    this.contentForm = this.fb.group({
      next: [this.statusLists[0]['statusName'], Validators.required],
    });
  }
  get f() {
    return this.contentForm.controls;
  }

  close() {
    this.dialogRef.close({ success: false });
  }

  onSubmit() {
    this.submitted = true;
    this.loader = true;
    if (this.contentForm.invalid) {
      return;
    }
    const data = {
      orderid: this.content.orderid,
      status: this.contentForm.value["next"],
    };
    if (this.contentForm.value["next"] === null) {
      data["status"] = this.content.status;
    }
    this.service
      .postMethod("callbackRequest/updateRequest/" + this.content.orderid, data)
      .then((data) => {
        console.log(data);
        this.loader = false;
        this.dialogRef.close({ success: true });
      })
      .catch((err) => {
        this.loader = false;
        this.global.failureErrorModal(err);
        this.errorMessage = "Unable to update status";
      });
  }
}
